import { ChakraProvider, theme } from "@chakra-ui/react"
import { TempNavigation } from './navigation/navigation'

export const App = () => (
  <ChakraProvider theme={theme}>
    <TempNavigation/>
  </ChakraProvider>
)
